import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { NepalPhoto } from './HomeEditorial';
import { loadJourneysPage } from '../../utils/cmsContentLoader';

const IMAGE_BY_SLUG = {
	'everest-base-camp': 'heroEverest',
	'annapurna-base-camp': 'annapurnaAbc',
	'langtang-valley': 'heroEverest',
};

function toHomeCard(journey, index) {
	return {
		slug: journey.slug,
		title: journey.title.replace(/\s+Journey$/i, ''),
		subtitle: journey.subtitle || journey.lead,
		duration: journey.duration_label || journey.quickFacts?.[0]?.value,
		difficulty: journey.difficulty_label || journey.quickFacts?.[1]?.value,
		coverage: journey.coverage,
		badge: index === 0 ? 'Benchmark' : 'Featured',
		isBenchmark: index === 0,
		route: `/journeys/${journey.slug}`,
		imageKey: IMAGE_BY_SLUG[journey.slug] || 'heroEverest',
	};
}

function HomeJourneyPanel() {
	const [featuredJourneys, setFeaturedJourneys] = useState([]);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		loadJourneysPage({ featured: true, per_page: 6 }, { staticFallback: true })
			.then(({ journeys }) => setFeaturedJourneys(journeys.map(toHomeCard)))
			.finally(() => setLoading(false));
	}, []);

	return (
		<div className="home-panel home-panel--journey">
			<div className="home-panel__head">
				<div>
					<span className="home-panel__eyebrow">Guided Journey</span>
					<h2 className="home-panel__title">Step-by-step trek execution</h2>
					<p className="home-panel__lead">
						Checklists, budget, timeline, documents wallet, and day-by-day panels — same UI, different trek data.
					</p>
				</div>
				<Link to="/journeys" className="home-panel__link">View all →</Link>
			</div>

			{loading ? (
				<p className="home-panel__lead">Loading featured journeys…</p>
			) : (
				<div className="home-journey-grid">
					{featuredJourneys.map((j) => (
						<Link key={j.slug} to={j.route} className="home-journey-card home-journey-card--compact">
							<div className="home-journey-card__media">
								<NepalPhoto imageKey={j.imageKey} className="home-journey-card__img" />
							</div>
							<div className="home-journey-card__body">
								<span className={`home-journey-card__badge${j.isBenchmark ? ' home-journey-card__badge--gold' : ''}`}>
									{j.badge}
								</span>
								<h3 className="home-journey-card__title">{j.title}</h3>
								<p className="home-journey-card__sub">{j.subtitle}</p>
								<ul className="home-journey-card__facts">
									{j.duration && <li>{j.duration}</li>}
									{j.difficulty && <li>{j.difficulty}</li>}
									<li>{j.coverage}% coverage</li>
								</ul>
								<span className="home-journey-card__cta">Open guided journey →</span>
							</div>
						</Link>
					))}
				</div>
			)}
		</div>
	);
}

export default HomeJourneyPanel;
